import { useEffect, useMemo, useState } from "react";
import { apiClient } from "./api";

// Tedarikci katalogundan bir kategori: marka + model (kategori adi) + STOKTA renkler.
// Renk stokta sayilir = o rengin en az bir bedeni stokta (sizes icinde bir true).
export type CatalogEntry = { brand: string; model: string; colors: string[] };

// Katalog verisinden marka/model/renk kademeli secim yardimcilari.
// - brands: tum markalar
// - modelsForBrand(brand): o markanin modelleri (marka bossa tum modeller)
// - colorsFor(brand, model): o marka+model icin stoktaki renkler (bos alanlar joker)
export function useSupplierVariations(vertical?: string) {
  const [entries, setEntries] = useState<CatalogEntry[]>([]);

  useEffect(() => {
    // Dikey verilirse yalnizca o dikeyin kataloglari — takı magazasinda
    // tekstil markalari (Gildan, Bella Canvas) filtrelerde cikmasin
    apiClient.listSupplierCatalogs(vertical).then((cats) => {
      const out: CatalogEntry[] = [];
      for (const cat of cats) {
        for (const pc of (cat.categories || [])) {
          const brand = (pc.brand || "").trim();
          const model = (pc.name || "").trim();
          if (!brand || !model) continue;
          const colors: string[] = [];
          for (const ca of (pc.colorAvailability || [])) {
            const inStock = Object.values(ca.sizes || {}).some(Boolean);
            if (inStock && ca.color) colors.push(ca.color.trim());
          }
          out.push({ brand, model, colors });
        }
      }
      setEntries(out);
    }).catch(() => { /* katalog yoksa sessiz */ });
  }, [vertical]);

  return useMemo(() => {
    const brands = [...new Set(entries.map((e) => e.brand))].sort();
    const modelsForBrand = (brand: string) =>
      [...new Set(entries.filter((e) => !brand || e.brand === brand).map((e) => e.model))].sort();
    const colorsFor = (brand: string, model: string) => {
      const s = new Set<string>();
      for (const e of entries) {
        if (brand && e.brand !== brand) continue;
        if (model && e.model !== model) continue;
        for (const c of e.colors) s.add(c);
      }
      return [...s].sort();
    };
    return { entries, brands, modelsForBrand, colorsFor, hasCatalog: brands.length > 0 };
  }, [entries]);
}
